import * as React from 'react';
import { FloatingHelperAppearance } from '..';

export type FloatingHelperContentActionTheme =
  | 'standard'
  | 'white'
  | 'premium'
  | 'lightPrimary'
  | 'standardPrimary';

export type FloatingHelperContentDirection = 'horizontal' | 'vertical';

export interface FloatingHelperContentProps {
  title?: string;
  body: React.ReactNode;
  actionText?: string;
  actionTheme?: FloatingHelperContentActionTheme;
  footer?: React.ReactNode;
  onActionClick?: () => void;
  image?: React.ReactNode;
  appearance?: FloatingHelperAppearance;
  direction?: FloatingHelperContentDirection;
}

export declare const FloatingHelperContent: React.ComponentClass<FloatingHelperContentProps>;
export default FloatingHelperContent;
